module.exports = __webpack_public_path__ + "static/media/generic-white-large.8892377b.svg";